import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IIntegratorListState } from "models/Slices/integratorListSlice.model";
import { integratorListAsync } from "redux/actions/IntegratorList.action";
import { IIntegratorList } from "models/Employee/IntegratoInfo.model";

const initialState: IIntegratorListState = {
  integratorList: null,
  selectedIntegratorObj: { label: "", value: "" },
  loading: false,
  error: "",
  success: false,
};

export const integratorListSlice = createSlice({
  name: "integratorList",
  initialState,
  reducers: {
    resetIntegratorList: () => initialState,
    resetIntegratorListError: (state) => {
      state.error = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(integratorListAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        integratorListAsync.fulfilled,
        (state, action: PayloadAction<IIntegratorList>) => {
          state.loading = false;
          state.integratorList = action.payload;
          state.success = !state.integratorList?.ErrorCode ? true : false;

          let defIntegrator = { label: "", value: "" };
          state.integratorList.Integrators.find(
            (e: any) =>
              e.Id === state.integratorList?.DefaultIntegratorId &&
              (defIntegrator = { label: e.Name, value: e.Id })
          );

          state.selectedIntegratorObj = { ...defIntegrator };
        }
      )
      .addCase(integratorListAsync.rejected, (state, action: any) => {
        state.loading = false;
        state.error = action.error?.message;
        state.success = false;
      });
  },
});

export const {
  resetIntegratorList,
  resetIntegratorListError,
} = integratorListSlice.actions;

export default integratorListSlice.reducer;
